import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './api';
import { AuditLogsRequest, AuditLogsResponse } from '../interfaces/auditLog.interface';

const baseUrl = `${import.meta.env.VITE_BACKEND_URL}/api`;

export const auditLogApi = createApi({
  reducerPath: 'auditLogApi',
  baseQuery: (...args) => baseQueryWithReAuth(...args, { baseUrl }),
  tagTypes: ['auditLog'],
  endpoints: (builder) => ({
    getAuditLogs: builder.query<AuditLogsResponse, AuditLogsRequest>({
      query: (body) => ({
        url: '/audit-logs',
        method: 'POST',
        body
      })
    })
  })
});

export const { useGetAuditLogsQuery, useLazyGetAuditLogsQuery } = auditLogApi;
